import styled from '@emotion/styled';

const Divider = styled.div(
  ({ theme, blank }) =>
    blank
      ? { marginBottom: 2 }
      : {
          backgroundColor: theme.color.basis5,
          margin: theme.spacing.small
        },
  ({ vertical = false }) => (vertical ? { width: 1, height: '100%' } : { height: 1, width: '100%' })
);

export default Divider;
